import React from 'react'
import PAID_LEAVE from '../../../../../constants'


const paidLeaveProducts = PAID_LEAVE.PRODUCTS

const PaidLeaveCell = (props) => {
  const productMap = props.location.productMap
  const productMapKeys = productMap ? Object.keys(productMap) : []

  const paidLeaveProductKeys = ['paidSickLeave', 'paidFamilyMedicalLeave', 'paidLeave']
  const relevantProductMapKeys = productMapKeys.filter((key) => paidLeaveProductKeys.includes(key))

  return (
    <div>
      {relevantProductMapKeys.length > 0 ? ProductList(productMap, relevantProductMapKeys) : <div>This location is not currently subject to any paid leave laws. Please see the Resources tab for any additional leave requirements, which may apply.</div>}
    </div>
  )
}

const ProductList = (productMap, relevantProductMapKeys) => {
  return (
    <div style={{ 'padding-top': '8px' }}>
      { relevantProductMapKeys.map((productKey) => (
        <div key={productKey} style={{ 'padding-top': '4px' }}>
          <span>{paidLeaveProducts.find((p) => p.id === productKey).name}</span>
          <span>{' - '}</span>
          <b>{productMap[productKey]}</b>
        </div>
      ))}
    </div>
  )
}

export default PaidLeaveCell
